import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConfiguration } from '@klubovna/api-client';
import { linksPublicControllerFindAllActive } from '@klubovna/api-client';
import { PublicLinkDto } from '@klubovna/api-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LinksPublicApiService {
  private readonly http = inject(HttpClient);
  private readonly apiConfig = inject(ApiConfiguration);

  findAllPublic(): Observable<PublicLinkDto[]> {
    return linksPublicControllerFindAllActive(this.http, this.apiConfig.rootUrl)
      .pipe(map(response => response.body as PublicLinkDto[]));
  }
}
